module.exports = __webpack_public_path__ + "static/media/star-ship_R.45d2cf6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/landscape/star-ship_R.png
// module id = 2219
// module chunks = 0